<template>
    <v-app dark>
      <v-content class="pa-0 ma-0">
        <pymescloudlogo class="animated slideInLeft" style="position:absolute; z-index:3;left:10px;top:10px;width:200px;height:auto">

        </pymescloudlogo>
      <v-container fluid fill-height>
       
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <fondoNubes style="position:absolute;left:0;top:0;rigth:0;bottom:0;z-index:2"></fondoNubes>
            <v-card v-if="AskLogin" class="elevation-12 animated fadeIn" style="z-index:3;border-radius:16px">
              <v-toolbar dark color="primary">
                <v-toolbar-title><v-icon large class="pr-2" style="opacity:0.6">mdi-account-key</v-icon>{{$t('login.inicia')}}</v-toolbar-title>
                <v-spacer></v-spacer>
                
                
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field prepend-icon="email" name="login" :label="$t('login.user')" type="text" v-model="login.email"></v-text-field>
                  <v-text-field required id="password" prepend-icon="lock" persistent-hint :hint="$t('login.passrecovery')" name="password" :label="$t('login.pass')" type="password" v-model="login.pass"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn flat round color="orange" @click="createAccount">{{$t('login.registrarse')}}</v-btn>
                <v-spacer></v-spacer>
                <v-btn :loading="login.loading" @click="Dologin" round color="primary">{{$t('login.acceder')}} <v-icon>mdi-chevron-right</v-icon></v-btn>
              </v-card-actions>
            </v-card>
            <v-dialog v-model="ShowAccountCreation" persistent max-width="500">
              <template>
                <v-card
                  class="mx-auto"
                  max-width="500"
                  style="border-radius:16px"
                >
                <v-toolbar dark color="primary">
                  <v-avatar
                      color="primary lighten-2"
                      class="subheading white--text"
                      size="24"
                      v-text="step"
                    ></v-avatar>
                <v-toolbar-title>{{currentTitle}}</v-toolbar-title>
                <v-spacer></v-spacer>
                 <v-btn
                      round icon
                      @click="cancelRegistro"
                    >
                    <v-icon>mdi-close</v-icon>
                    </v-btn>
                
              </v-toolbar>
                 

                  <v-window v-model="step">
                    <v-window-item :value="1">
                      <v-card-text>
                        <v-text-field
                          :label="$t('login.registro.email.label')"
                          :placeholder="$t('login.registro.email.default')"
                          v-model="newAccount.email"
                        ></v-text-field>
                        <span class="caption grey--text text--darken-1">
                          {{$t('login.registro.email.description')}}
                        </span>
                      </v-card-text>
                    </v-window-item>

                    <v-window-item :value="2">
                      <v-card-text>
                        <v-text-field
                          label="Contraseña"
                          type="password"
                          v-model="newAccount.pass"
                        ></v-text-field>
                        <v-text-field
                          label="Confirmar Contraseña"
                          type="password"
                          v-model="newAccount.passconfirm"
                        ></v-text-field>
                        <span class="caption grey--text text--darken-1">
                          {{$t('login.registro.pass.description')}}
                        </span>
                      </v-card-text>
                    </v-window-item>

                    <v-window-item :value="3">
                      <div class="pa-3 text-xs-center">
                        <v-icon x-large>mdi-check</v-icon>
                        <h3 class="title font-weight-light mb-2">{{$t('login.registro.gracias')}}</h3>
                        <span class="caption grey--text">{{$t('login.registro.confirmacion')}}</span>
                      </div>
                    </v-window-item>
                  </v-window>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-btn
                      :disabled="step === 1"
                      flat
                      round
                      @click="RegistroRegresar"
                    >
                      Regresar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      :disabled="step === 3"
                      color="primary"
                      depressed
                      round
                      @click="RegistroSiguiente"
                    >
                      Siguiente
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
          </v-flex>
        </v-layout>
      </v-container>
        </v-content>

    </v-app>
</template>

<script>
    export default {
        name: 'miPyMEScloud',
        components: {
            pymescloudlogo: () => import('@/components/svg/pymescloud'),
            fondoNubes: () => import('@/components/fondos/nubes')
        },
        data() {
            return {
              AskLogin: true,
              ShowAccountCreation: false,
                appName: 'miPyMEs.cloud',
                fixed: false,
                step: 1,
                login: {
                  email: '',
                  pass: '',
                  loading: false
                },
                newAccount: {
                  email: '',
                  pass: '',
                  passconfirm: ''
                }
            }
        },
        methods: {
          createAccount() {
            this.AskLogin = false
            this.ShowAccountCreation = true
          },
          cancelRegistro() {
            this.AskLogin = true
            this.ShowAccountCreation = false
          },
          RegistroSiguiente() {},
          RegistroRegresar() {},
          Dologin() {
            this.login.loading = true
            this.$auth.signInWithEmailAndPassword(this.login.email, this.login.pass).then(ok => {
              this.login.loading = false
              this.$Bus.$emit('ALERT', {
                text: `Exito!`,
                color: 'success'
              })
            }).catch(function(error) {
              this.login.loading = false
              this.$Bus.$emit('ALERT', {
                text: `Error: ${error}`,
                color: 'error'
              })
              var errorCode = error.code;
              var errorMessage = error.message;
              
            })
          }
        },
        computed: {
          currentTitle () {
            switch (this.step) {
              case 1: return 'Registro'
              case 2: return 'Tu Contraseña'
              default: return 'Confirma tu Registro'
            }
          }
        }
    }
</script>

<style scoped lang="stylus">
    @import '../../node_modules/vuetify/src/stylus/settings/_variables.styl';

    .bottom-menu {
        position: absolute;
        width: 100%;
        bottom: 0;
    }

    .searching {
        overflow: hidden;
        width: 208px;
        padding-left: 8px;
        transition: $primary-transition;
    }

    .searching--closed {
        padding-left: 0;
        width: 0;
    }

    .searching > * {
        right: 8px;
    }

    .searching--closed > * {
        display: none;
    }

    .hidden-searching {
        @media $display-breakpoints.sm-and-down {
            display: none !important;
        }
    }

    .list-border-bottom {
        border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    }
</style>
